import React, { useEffect, useState } from "react";
import { Table, TableColumn } from "../../../components/table";
import HeaderBar from "../../../components/header/headerBar";
import IconMdi from "@mdi/react";
import { mdiPencilCircle, mdiDelete, mdiPlus } from "@mdi/js";
import { SearchField } from "../../../components/textfield";
import Select from "../../../components/select/select";
import Button from "../../../components/button/Button";
import Import from "../../../components/button/Import";
import { useHistory } from "react-router-dom";
import { Modal } from "antd";
import { Icon } from "@iconify/react";

const AddStock = () => {
  const { confirm } = Modal;
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [state, setState] = useState<any>({
    data: [],
  });

  const columns = [
    {
      title: "",
    },
    {
      title: "รหัส",
    },
    {
      title: "ชื่อรายการ",
    },
    {
      title: "หน่วย",
    },
    {
      title: "ราคา/หน่วย",
    },
    {
      title: "จำนวนคงเหลือ",
    },
    {
      title: "อัพเดทล่าสุด",
    },
    {
      title: "Action",
      align: "center",
      colspan: 2,
    },
  ];
  const data = [
    {
      _id: 1,
      cn: "RA-01-001",
      list: "216 Adjustable comfort bra, Size 34",
      unit: "ชิ้น",
      price: 150.0,
      remaining: 100,
      latestUpdate: "25-08-2564",
    },
    {
      _id: 2,
      cn: "RA-01-002",
      list: "215 Adjustable comfort bra, Size 32",
      unit: "ชิ้น",
      price: 100.0,
      remaining: 150,
      latestUpdate: "25-08-2564",
    },
  ];
  const option = [
    { value: "branch1", name: "All" },
    { value: "branch2", name: "All" },
    { value: "branch3", name: "All" },
    { value: "branch4", name: "All" },
  ];

  function onClose() {
    setIsOpen(false);
  }

  const getAPIs = () => {
    setState({ ...state, data: data });
  };

  function showDeleteConfirm(id: any, name: any ) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{marginBottom: "28px"}}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        // deleteData(id);
      },
      width: "fit-content"
    });
  }

  useEffect(() => {
    getAPIs();
  }, []);

  return (
    <div>
      <HeaderBar title="ADD STOCK" />

      <div style={{ padding: "10px 40px" }}>
        <SearchField placeholder="Search for Stock (Code, Name)" color="#fff" />
        <div style={{ marginTop: "20px" }}>
          <div className="email_type">
            <Select title="CATEGORY :" option={option} />
          </div>
          <div className="button-add-import">
            <Button
              title="เพิ่มสินค้าใหม่"
              width={175}
              to={`/setting/stock/addStock/createProduct`}
            >
              <IconMdi path={mdiPlus} size="20" />
            </Button>
          </div>
          <div className="button-add">
            <Import title="นำเข้าไฟล์ (Excel)" width={175}>
              <IconMdi path={mdiPlus} size="20" />
            </Import>
          </div>
        </div>
        <div style={{ marginTop: "100px" }}>
          <Table header={columns}>
            {state.data.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="10%">{item.cn}</TableColumn>
                <TableColumn width="25%">{item.list}</TableColumn>
                <TableColumn width="5%">{item.unit}</TableColumn>
                <TableColumn width="5%">{item.price}</TableColumn>
                <TableColumn width="5%">{item.remaining}</TableColumn>
                <TableColumn width="5%">{item.latestUpdate}</TableColumn>
                <TableColumn width="5%" align="center">
                  <div
                    onClick={() => {
                      history.push(
                        `/setting/stock/addStock/${item._id}/createProduct`
                      );
                    }}
                  >
                    <IconMdi path={mdiPencilCircle} size="30" color="#5BAEA9" />
                  </div>
                </TableColumn>
                <TableColumn
                  width="5%" 
                  align="center" 
                  onClick={() => {
                    showDeleteConfirm(item._id, item.list)
                  }}
                >
                  <div>
                    <IconMdi path={mdiDelete} size="25" color="#FF6760"></IconMdi>
                  </div>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default AddStock;
